/** @type {number} The minimum character length for a committed learning to be considered valid */
export const MIN_LEARNING_LENGTH = 20;

export const LEARNING_DECISIONS = {
  PROPOSE_NEW: 'propose_new',
  UPDATE_EXISTING: 'update_existing',
  DELETE_EXISTING: 'delete_existing',
  REDUNDANT: 'redundant',
  SKIP: 'skip',
};

export const ACTIONABLE_LEARNING_DECISIONS = [
  LEARNING_DECISIONS.PROPOSE_NEW,
  LEARNING_DECISIONS.UPDATE_EXISTING,
  LEARNING_DECISIONS.DELETE_EXISTING,
];

/**
 * Only an active learning is applied to audits. A draft has never passed the safety check, so nothing may
 * inject it into the auditor's prompt.
 */
export const LEARNING_STATUSES = {
  ACTIVE: 'active',
  DRAFT: 'draft',
};

export const LEARNING_SOURCES = {
  MANUAL: 'manual',
  FEEDBACK: 'feedback',
};

/**
 * The two answers to "what does this apply to". Not a stored field — a learning is organization-scoped
 * when it names no template — but the modal needs a value to bind its selector to.
 */
export const LEARNING_SCOPE_OPTIONS = {
  ORGANIZATION: 'organization',
  TEMPLATES: 'templates',
};
